import React, { Component } from "react";
import Images from "../../Images";

export class LiveMatches extends Component {
  render() {
    return (
      <div className="live-slides">
        <div className="home-live-matches">
          <div className="head-line">
            <div>
              <img src={Images.SoccerTest} />
              <span>Germany / Bundesliga</span>
            </div>
            <div className="match-id">ID: 8685</div>
          </div>
          <div className="live-info">
            <div className="team-container">
              <img src={Images.DummyTeam} />
              <span>Germany / Bundesliga</span>
            </div>
            <div className="live-score">2 : 0</div>
            <div className="team-container">
              <img src={Images.DummyTeam} />
              <span>Germany / Bundesliga</span>
            </div>
          </div>
          <div className="end-line">
            <div>
              <span>1</span> <span className="value">1.89</span>
            </div>
            <div>
              <span>1</span> <span className="value">1.89</span>
            </div>
            <div>
              <span>1</span> <span className="value">1.89</span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default LiveMatches;
